import { BaseModel } from "model/BaseModel";

export default class OperacaoProducao implements BaseModel {
    id: number;
    codigo: string | null="";
    descricao: string;
    quantidadeOperadores: number;
    tempoExecucao: number;
    qualidade: boolean;

    constructor(
        id = 0,
        descricao = '',
        quantidadeOperadores = 0,
        tempoExecucao = 0,
        qualidade = false
    ) {
        this.id = id;
        this.descricao = descricao;
        this.quantidadeOperadores = quantidadeOperadores;
        this.tempoExecucao = tempoExecucao;
        this.qualidade = qualidade;
    }
}